<template>
  <div>
      <el-avatar v-if="avatarUrl && avatarUrl != 'https://example.com'" :src="getImageUrl()" :size="size" :class="'avatar-name'" ></el-avatar>
      <el-avatar v-else :v-bind="$attrs" :size="size" :class="'avatar-name ' + backgAvatar">
          {{avatarName.toUpperCase()}}
      </el-avatar>
  </div>
</template>

<script>
  import { isEmpty, compose, propOr, is, last, slice, pathOr } from 'ramda'

  export default {
    components: {

    },
    props: {
      avatarUrl: {
        type: String,
        default: "",
      },
      userObject: {
          default: null
      },
      indx: {
          default: 0,
      },
      size: {
          default: "medium"
      },
      screen: {
        type: String,
        default: ""
      }
    },
    data() {
      return {
        logo_bucket_path: process.env.VUE_APP_PATH_S3_BUCKET,
        logo_cloudfront_path: process.env.VUE_APP_CLOUDFRONT_AVATAR_URL,
      }
    },
    computed: {
      avatarName() {
        if(is(String, this.userObject)){
          return this.buildAvaName(this.userObject)
        }

        return this.userObject ? `${compose(slice(0,1), propOr('', 'first_name'))(this.userObject)} ${compose(slice(0,1), propOr('', 'last_name'))(this.userObject)}` : ''
      },
      backgAvatar() {
          const mod = (this.indx + 3) % 3;
          return this.backgSwitch(mod)
      },
    },
    methods: {
        buildAvaName(name){
            let words = name.split(' ');
            return words.length > 1 ? `${words[0].charAt(0)} ${last(words).charAt(0)}` : `${words[0].charAt(0)}`
        },
        backgSwitch(mod) {
            const backgrounds = {
                0: "blue-backg",
                1: "purple-backg",
                2: "yellow-backg"
            }
            return backgrounds[mod];
        },
        getImageUrl() {
          return this.screen === 'branch' ? (this.logo_bucket_path + this.avatarUrl) : this.avatarUrl;
        }
    },
  }
</script>

<style lang="scss" scoped>
@import "../../scss/_colors.scss";
.avatar-name {
  color: $white;
  font-weight: bold;
  margin-right: 15px;
  letter-spacing: -1.6px;
}

.purple-backg {
  background-color: $blue;
}

.blue-backg {
  background-color: $purple;
}

.yellow-backg {
  background-color: $yellow;
}
</style>
